import { Routes, Route } from "react-router-dom";
import AuthRoutes from "./auth-routes";
import HostRoutes from "./host-routes";
import AttendeRoutes from "./attendee-routes";
import { Fragment } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import Loader from "../components/loader";
import MinorRoutes from "./minor-routes";
import AmbassadorRoutes from "./ambassador-routes";
import RsvpRoutes from "./rsvp-routes";
import ProtectedRoutes from "guards/protected-routes";
import NonProtectedRoutes from "guards/non-protected-routes";
const AppRoutes = () => {
  const { isLoading } = useSelector((state: any) => state.sharedReducer);

  return (
    <Fragment>
      {isLoading && <Loader />}
      <Routes>
        <Route path="/auth/*" element={<NonProtectedRoutes children={<AuthRoutes />}/>} />
        <Route path="/*" element={<ProtectedRoutes children={<HostRoutes />}/>} />
        <Route path="/attendee/*" element={<ProtectedRoutes children={<AttendeRoutes />}/>} />
        <Route path="/minor/*" element={<ProtectedRoutes children={<MinorRoutes />}/>} />
        <Route path="/ambassador/*" element={<ProtectedRoutes children={<AmbassadorRoutes />}/>} />
        <Route path="/rsvp/*" element={<ProtectedRoutes children={<RsvpRoutes />}/>} />
      </Routes>
    </Fragment>
  );
};

export default AppRoutes;
